import React from 'react'

const ContactMap = () => {
  return (
    <div>ContactMap</div>
  )
}

export default ContactMap